import angular from 'angular';
import _ from 'lodash';
import AuditAction from '../data/audit/audit-action.data';

(function () {
    'use strict';
    angular.module('app.core').factory('AuditDA', AuditDA);

    AuditDA.$inject = ['logger', 'Restangular', 'CONF', 'AUDIT', 'Audit'];

    /* @ngInject */
    function AuditDA(logger, Restangular, CONF, AUDIT, Audit) {
        var baseUrl = CONF.apiBaseUrl + '/v1/audits';

        var exports = {
            searchAudit: searchAudit,
            downloadReportFile: downloadReportFile,
            getActions: getActions,
        };

        return exports;

        /**
         * Recherche d'audit.
         */
        function searchAudit(auditFilter) {
            var filter = auditFilter.preparBeforeSearch();
            return Restangular.one(baseUrl)
                .all('search')
                .post(filter)
                .then(function (auditData) {
                    return {
                        totalItems: auditData.totalElements,
                        audits: _.map(auditData.content, function (s) {
                            return new Audit(s);
                        }),
                    };
                });
        }

        /**
         * Recupere la liste des actions d'audit.
         */
        function getActions() {
            return Restangular.one(baseUrl)
                .one('actions')
                .get()
                .then(data => {
                    var aoFinal = _.filter(data, ao => ao.parent);
                    return _.map(aoFinal, ao => new AuditAction(ao));
                });
        }

        /**
         * Récupération d'un fichier de rapport.
         */
        function downloadReportFile(auditId, format) {
            return CONF.apiContext + baseUrl + '/' + auditId + '/report-file/' + format;
        }
    }
})();
